// extracted by mini-css-extract-plugin
export default {"footnote":"list_footnote__hUWyw"};